const radioGroupKey = Symbol("radioGroupKey");

export { radioGroupKey };
//# sourceMappingURL=radio.mjs.map
